export default "__VITE_ASSET__CYk06C98__"